export class LocalStorageService {
  constructor() {}

  public static set(key: string, data: any) {
    localStorage.setItem(key, JSON.stringify(data))
  }

  public static get(key: string): any {
    return JSON.parse(localStorage.getItem(key) ?? null)
  }

  public static remove(key: string) {
    localStorage.removeItem(key)
  }
}
